<header class="header">
    <div class="header-left">
        <img src="assets/img/logo.png" alt="Logo Órgano Judicial" class="logo">
        <h5>Documento de Aceptación: Deberá leer y aceptar los siguientes documentos.</h5>
    </div>
    <div class="header-right">
        <a class="btn txt-oscuro" href="javascript:void(0);"  (click)="logout()"><span title="Cerrar sesión"
                class="fas fa-sign-out-alt"></span></a>
    </div>
</header>
@if(reiniciando){
<div class="loading-overlay">
    <div class="loading-indicator">Cerrando sesión...</div>
</div>
}


<div>
    <oaj-alert-itx></oaj-alert-itx>
</div>
<br>
<div class="container-fluid">
    <div class="d-flex align-items-center justify-content-center min-vh-80 bg-light p-3">
        <div class="card shadow-sm" style="max-width: 1000px; width: 100%;">
            <div class="card-body">
                <label for="chkAviPriv" class="form-label"><b>Favor de leer y aceptar los siguientes documentos, al término de lo cual, deberá firmar el de aceptación de los Términos y Condiciones del uso de la plataforma.</b></label>
                <br>
                <br>
                <div class="form-group row">
                    <div class="col-12">
                        <label>
                            <input type="checkbox" [(ngModel)]="chkAviPriv" name="opcion1" value="1">
                            He leído el <a
                                href="https://www.oaj.gob.mx/transparencia/resources/avisosPrivacidad/Aviso_Integral_PortalServiciosLineaPoderJudicialFederacion-2026.pdf"
                                target="_blank">Aviso de Privacidad</a> y otorgo mi consentimiento para que los datos
                            personales
                            sean tratados conforme al mismo.
                        </label>
                    </div>
                </div>
                <br>
                <div class="form-group row">
                    <div class="col-12">
                        <label>
                            <input type="checkbox" [(ngModel)]="chkTerCon" name="opcion2" value="2">
                            He leído y acepto los <a
                                href="assets/doctos/Términos y Condiciones Plataforma Interconexión.pdf"
                                target="_blank">Términos y Condiciones </a>de Adhesión para la Interconexión
                            Tecnológica.
                        </label>
                    </div>
                </div>
                <br>

                <div class="row mt-3">
                    <div class="col-12 col-sm-auto">
                        <!-- <button class="btn btn-file" (click)="cargaArchivo()" [disabled]="!(chkAviPriv && chkTerCon)">Firmar documentos
                                </button> -->
                        <button class="btn btn-file" (click)="openWindowFirma()"
                            [disabled]="!(chkAviPriv && chkTerCon)">
                            @if(!loading){
                            <span>Firmar Términos y Condiciones</span>
                            }
                            @else{
                            <span class="d-flex align-items-center justify-content-center">
                                <span class="spinner-border spinner-border-sm me-2" role="status"
                                    aria-hidden="true"></span>
                                Procesando...
                            </span>
                            }
                        </button>
                    </div>
                </div>

                <!-- <div class="row">
                        <div class="col-12 col-sm-auto">
                            <div class="center">
                                <oaj-loader-itx [loading]="isLoadingFile" [sMensaje]="sMensajeLoad" #loaderSpinner></oaj-loader-itx>
                            </div>
                            @if(!isLoadingFile){
                            <oaj-lista-archivos-itx class="form-control" [archivos]="lstDocumentos" [verBorrar]="false"
                                [verPrevisualizar]="true" [OcultaSystemName]="true">
                            </oaj-lista-archivos-itx>
                            }
                        </div>
                    </div> -->

                <br />
                <br />
            </div>
        </div>
    </div>
</div>